import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _pick from 'lodash/pick';
import _kebabCase from 'lodash/kebabCase';
import { BREAKPOINTS } from '../spacing/index.js';

var _excluded = ["maximum", "minimum"];

var validStyles = ['width', 'height', 'maxWidth', 'maxHeight', 'minWidth', 'minHeight', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'textTransform']; // whitelist of customizable breakpoints

var validBreakpoints = Object.values(BREAKPOINTS); // create css rules from an object containing pascal case style rules

var createCSS = function createCSS(rules) {
  return Object.keys(rules).reduce(function (acc, key) {
    var cssKey = _kebabCase(key);

    return "".concat(acc, "\n    ").concat(cssKey, ": ").concat(rules[key], ";");
  }, '');
};

var createMediaQueryRule = function createMediaQueryRule(maximum, minimum) {
  var queryAcc = [];

  if (maximum && validBreakpoints.includes(maximum)) {
    queryAcc.push("(max-width: ".concat(maximum, "px)"));
  }

  if (minimum && validBreakpoints.includes(minimum)) {
    queryAcc.push("(min-width: ".concat(minimum, "px)"));
  }

  return queryAcc.join(' and ');
};

var safeCustomStyle = function safeCustomStyle(customStyle) {
  return Object.keys(customStyle).reduce(function (acc, subcomponent) {
    var styleObject = customStyle[subcomponent];

    if (!styleObject) {
      return acc;
    }

    var baseStyle = createCSS(_pick(styleObject, validStyles));
    var mediaQueries = styleObject.media ? styleObject.media.reduce(function (queries, _ref) {
      var maximum = _ref.maximum,
          minimum = _ref.minimum,
          mediaStyles = _objectWithoutProperties(_ref, _excluded);

      var mediaQueryRule = createMediaQueryRule(maximum, minimum);

      if (!mediaQueryRule) {
        // breakpoints are invalid; skip
        return queries;
      }

      return "".concat(queries, "\n              @media ").concat(mediaQueryRule, " {\n                ").concat(createCSS(_pick(mediaStyles, validStyles)), "\n              }\n            ");
    }, '') : '';
    acc[subcomponent] = "".concat(baseStyle).concat(mediaQueries);
    return acc;
  }, {});
};

export default safeCustomStyle;
export { validStyles };
